import classNames from 'classnames';
import styles from './booking-list-item.module.scss';
import { FC } from 'react';
import dayjs from 'dayjs';

export type BookingListItemProductProps = {
  productTypeTitle: string;
  bookingDateRange: {
    gte: Date;
    lte: Date;
  };
  rentalStationName: string;
  amount: number;
  translations: {
    productTypeLabel: string;
    dateRangeFrom: string;
    dateRangeTo: string;
    rentalStationNameLabel: string;
  };
}

export const BookingListItemProduct: FC<BookingListItemProductProps> = ({
  productTypeTitle, bookingDateRange, rentalStationName, amount, translations,
}) => {
  return (
    <div className={classNames(styles.orderItemProduct, styles.orderItem)}>
      <div className={styles.orderItemProductLeft}>
        <label className={styles.label}>{translations.productTypeLabel}:</label>
        <p className={styles.value}>
          <strong>{amount} x {productTypeTitle}</strong>
        </p>
      </div>

      <div className={styles.dateRange}>
        <div>
          <label className={styles.label}>{translations.dateRangeFrom}:</label>
          <p className={styles.value}>{dayjs(bookingDateRange.gte).format('DD.MM.YYYY')}</p>
        </div>
        <div>
          <label className={styles.label}>{translations.dateRangeTo}:</label>
          <p className={styles.value}>{dayjs(bookingDateRange.lte).format('DD.MM.YYYY')}</p>
        </div>
      </div>

      <div className={styles.orderItemProductRight}>
        <div>
          <label className={styles.label}>{translations.rentalStationNameLabel}:</label>
          <p className={styles.value}>{rentalStationName}</p>
        </div>
      </div>
    </div>
  );
};
